import api from "./axios";

const EndPoints = {
  join(id: string) {
    return `/merchant/settings/team/${id}/join`;
  },
};

export const joinViaInvite = async (id: string, payload: unknown) => {
  const res = await api.post(EndPoints.join(id), payload);
  return res;
};
